(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-custom"]) return;
  try {
    
  (function () {
    // -------- Shopify money formatter (kompakt) --------
    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var f = format || '${{amount}}';
      function withDelimiters(number, precision, thousands, decimal) {
        precision = (precision == null) ? 2 : precision;
        thousands = thousands || ',';
        decimal = decimal || '.';
        if (isNaN(number) || number == null) return '0';
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
      }
      var value = '';
      var match = f.match(placeholderRegex);
      var token = match ? match[1] : 'amount';
      switch (token) {
        case 'amount': value = withDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
        case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
        default: value = withDelimiters(cents, 2);
      }
      return f.replace(placeholderRegex, value);
    }

    // -------- Galerie --------
    function initGallery(section) {
      var gallery = section.querySelector('[data-pm-gallery]');
      if (!gallery || gallery.dataset.pmReady) return;
      gallery.dataset.pmReady = '1';

      // Box-Ansicht: Vorschaubild und Lightbox-Vorschaubild fürs Box-Bild vorne einsetzen, Zählung neu
      if (gallery.querySelector('[data-pm-box]')) {
        [['template[data-pm-box-thumb]', gallery.querySelector('[data-pm-thumbs]'), 'data-pm-thumb'], ['template[data-pm-box-zthumb]', section.querySelector('[data-pm-zoom-thumbs]'), 'data-pm-zoom-thumb']].forEach(function (x) {
          var tp = gallery.querySelector(x[0]), box = x[1]; if (!tp || !box) return;
          box.insertBefore(tp.content.cloneNode(true), box.firstElementChild);
          box.querySelectorAll('[' + x[2] + ']').forEach(function (b, i) { b.setAttribute(x[2], i); b.setAttribute('aria-label', String(b.getAttribute('aria-label') || '').replace(/\d+$/, String(i + 1))); b.classList.toggle('is-active', i === 0 && x[2] === 'data-pm-thumb'); });
        });
        var bf0 = gallery.querySelector('[data-pm-bar-fill]'), n0 = gallery.querySelectorAll('[data-pm-slide]').length; if (bf0 && n0) bf0.style.width = (100 / n0) + '%';
      }

      var track = gallery.querySelector('[data-pm-track]');
      var slides = gallery.querySelectorAll('[data-pm-slide]');
      var thumbs = gallery.querySelectorAll('[data-pm-thumb]');
      var barFill = gallery.querySelector('[data-pm-bar-fill]');

      function setActive(index) {
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var i = parseInt(thumb.dataset.pmThumb, 10);
          var slide = slides[i];
          if (slide && track) {
            track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          }
          setActive(i);
        });
      });

      // Aktiven Thumb beim Scrollen mitziehen (per rAF -> sofort & flüssig)
      if (track) {
        var rafPending = false;
        track.addEventListener('scroll', function () {
          if (rafPending) return;
          rafPending = true;
          requestAnimationFrame(function () {
            rafPending = false;
            if (barFill && slides.length > 1) {
              var p = track.scrollLeft / Math.max(1, track.scrollWidth - track.clientWidth);
              barFill.style.transform = 'translateX(' + (Math.min(1, Math.max(0, p)) * (slides.length - 1) * 100) + '%)';
            }
            var center = track.scrollLeft + track.clientWidth / 2;
            var best = 0, bestDist = Infinity;
            slides.forEach(function (s, i) {
              var mid = s.offsetLeft + s.offsetWidth / 2;
              var d = Math.abs(mid - center);
              if (d < bestDist) { bestDist = d; best = i; }
            });
            setActive(best);
          });
        }, { passive: true });
      }

      // Lightbox (Vollbild-Viewer mit Pfeilen + Thumbnails)
      var lightbox = section.querySelector('[data-pm-lightbox]');
      var lbImg = section.querySelector('[data-pm-zoom-img]');
      var lbStage = section.querySelector('[data-pm-zoom-stage]');
      var openBtn = gallery.querySelector('[data-pm-zoom-open]');
      var closeBtn = section.querySelector('[data-pm-zoom-close]');
      var prevBtn = section.querySelector('[data-pm-zoom-prev]');
      var nextBtn = section.querySelector('[data-pm-zoom-next]');
      var lbThumbs = section.querySelectorAll('[data-pm-zoom-thumb]');

      var zoomImages = [];
      slides.forEach(function (s) {
        var im = s.querySelector('[data-pm-zoom-src]');
        var img = s.querySelector('img');
        zoomImages.push(im ? (im.getAttribute('data-pm-zoom-src') || im.src) : (img ? img.src : ''));
      });
      var lbIndex = 0;

      // Pinch-/Pan-Zoom (Touch)
      var zScale = 1, zTx = 0, zTy = 0;
      var pStartDist = 0, pStartScale = 1, pStartX = 0, pStartY = 0, pStartTx = 0, pStartTy = 0, pMoved = false;
      var Z_MAX = 4;
      function zApply() { if (lbImg) lbImg.style.transform = 'translate(' + zTx + 'px,' + zTy + 'px) scale(' + zScale + ')'; }
      function zReset() { zScale = 1; zTx = 0; zTy = 0; if (lbImg) { lbImg.style.transform = ''; lbImg.classList.remove('is-zoomed'); } }
      function zDist(a, b) { var dx = a.clientX - b.clientX, dy = a.clientY - b.clientY; return Math.sqrt(dx * dx + dy * dy); }
      function zClamp() {
        if (!lbImg) return;
        var maxX = (lbImg.clientWidth * (zScale - 1)) / 2;
        var maxY = (lbImg.clientHeight * (zScale - 1)) / 2;
        zTx = Math.max(-maxX, Math.min(maxX, zTx));
        zTy = Math.max(-maxY, Math.min(maxY, zTy));
      }

      function currentGalleryIndex() {
        if (!track) return 0;
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (s, i) {
          var mid = s.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(mid - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }
      function lbShow(index) {
        if (!zoomImages.length) return;
        lbIndex = (index + zoomImages.length) % zoomImages.length;
        if (lbImg) { lbImg.src = zoomImages[lbIndex]; }
        zReset();
        lbThumbs.forEach(function (t) {
          t.classList.toggle('is-active', parseInt(t.getAttribute('data-pm-zoom-thumb'), 10) === lbIndex);
        });
        var active = section.querySelector('[data-pm-zoom-thumb="' + lbIndex + '"]');
        if (active && active.scrollIntoView) active.scrollIntoView({ inline: 'center', block: 'nearest' });
      }
      function openLb() {
        if (!lightbox) return;
        lbShow(currentGalleryIndex());
        lightbox.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }
      function closeLb() {
        if (!lightbox) return;
        lightbox.hidden = true;
        document.documentElement.style.overflow = '';
      }
      if (openBtn) openBtn.addEventListener('click', openLb);
      if (closeBtn) closeBtn.addEventListener('click', closeLb);
      if (prevBtn) prevBtn.addEventListener('click', function () { lbShow(lbIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { lbShow(lbIndex + 1); });
      lbThumbs.forEach(function (t) {
        t.addEventListener('click', function () { lbShow(parseInt(t.getAttribute('data-pm-zoom-thumb'), 10)); });
      });
      if (lbImg) {
        // Klick-Zoom (Desktop); bei Touch-Gesten unterdrückt
        lbImg.addEventListener('click', function () {
          if (pMoved) return;
          if (zScale > 1) { zReset(); }
          else { zScale = 2; lbImg.classList.add('is-zoomed'); zApply(); }
        });
        // Pinch (2 Finger) + Pan (1 Finger, wenn gezoomt)
        lbImg.addEventListener('touchstart', function (e) {
          if (e.touches.length === 2) {
            pStartDist = zDist(e.touches[0], e.touches[1]); pStartScale = zScale; pMoved = true;
          } else if (e.touches.length === 1 && zScale > 1) {
            pStartX = e.touches[0].clientX; pStartY = e.touches[0].clientY; pStartTx = zTx; pStartTy = zTy;
          }
        }, { passive: true });
        lbImg.addEventListener('touchmove', function (e) {
          if (e.touches.length === 2 && pStartDist > 0) {
            e.preventDefault();
            var d = zDist(e.touches[0], e.touches[1]);
            zScale = Math.max(1, Math.min(Z_MAX, pStartScale * (d / pStartDist)));
            if (zScale <= 1) { zTx = 0; zTy = 0; }
            zClamp(); zApply();
            lbImg.classList.toggle('is-zoomed', zScale > 1);
            pMoved = true;
          } else if (e.touches.length === 1 && zScale > 1) {
            e.preventDefault();
            zTx = pStartTx + (e.touches[0].clientX - pStartX);
            zTy = pStartTy + (e.touches[0].clientY - pStartY);
            zClamp(); zApply(); pMoved = true;
          }
        }, { passive: false });
        lbImg.addEventListener('touchend', function (e) {
          if (e.touches.length === 0) {
            if (zScale <= 1.02) zReset();
            if (pMoved) setTimeout(function () { pMoved = false; }, 60);
          }
        });
      }
      if (lbStage) lbStage.addEventListener('click', function (e) { if (e.target === lbStage) closeLb(); });
      document.addEventListener('keydown', function (e) {
        if (!lightbox || lightbox.hidden) return;
        if (e.key === 'Escape') closeLb();
        else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
        else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
      });
    }

    // -------- Buy Box --------
    function initBuyBox(section) {
      var form = section.querySelector('[data-pm-form]');
      if (!form || form.dataset.pmReady) return;
      form.dataset.pmReady = '1';

      var moneyFormat = form.dataset.moneyFormat || '${{amount}}';

      // Welche Variante des Varianten-Blocks ist eingebunden?
      var brs = form.querySelector('[data-pm-brs]');
      if (brs) { initBuyBoxBRS(section, form, brs, moneyFormat); return; }
      initBuyBoxInitialRing(section, form, moneyFormat);
    }

    // ============================================================
    // Initialen-Ring (Solo / Le Duo)
    // ============================================================
    function initBuyBoxInitialRing(section, form, moneyFormat) {

      function checkedColor(ring) {
        return form.querySelector('input[name="pm_ring' + ring + '_color"]:checked');
      }
      function isDuo() {
        var m = form.querySelector('input[name="pm_mode"]:checked');
        return m ? m.value === 'duo' : false;
      }
      function updateModeClass() {
        form.classList.toggle('pm--duo', isDuo());
      }

      function fmtInto(priceSel, compareSel, priceCents, compareCents) {
        var priceEl = form.querySelector(priceSel);
        var compareEl = form.querySelector(compareSel);
        if (priceEl && !isNaN(priceCents)) priceEl.textContent = formatMoney(priceCents, moneyFormat);
        if (compareEl) {
          if (compareCents > priceCents) {
            compareEl.textContent = formatMoney(compareCents, moneyFormat);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      }

      // Preise (Hauptpreis + Solo-Zeile) aus der Ring-I-Variante. Le-Duo-Preis
      // ist fester Text im Varianten-Block und wird hier NICHT berechnet.
      function updatePrice() {
        var c = checkedColor(1);
        if (!c) return;
        var price = parseInt(c.getAttribute('data-variant-price'), 10);
        var compare = parseInt(c.getAttribute('data-variant-compare'), 10) || 0;
        fmtInto('[data-pm-price]', '[data-pm-compare]', price, compare);
        fmtInto('[data-pm-solo-price]', '[data-pm-solo-compare]', price, compare);
      }

      // Galerie NUR bei aktiver Farbwahl umschalten (nicht beim Laden).
      function switchGalleryTo(colorInput) {
        if (!colorInput) return;
        var mediaId = colorInput.getAttribute('data-variant-media');
        if (!mediaId) return;
        var slide = section.querySelector('[data-pm-slide][data-media-id="' + mediaId + '"]');
        var track = section.querySelector('[data-pm-track]');
        if (slide && track) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      // "Farbe: X" pro Ring aktualisieren.
      function updateColorName(colorInput) {
        if (!colorInput) return;
        var ring = colorInput.closest('[data-ring]');
        var span = ring ? ring.querySelector('[data-pm-color-name]') : null;
        if (span) span.textContent = colorInput.value;
      }
      function refreshAllColorNames() {
        [1, 2].forEach(function (r) { updateColorName(checkedColor(r)); });
      }

      function recompute() {
        updateModeClass();
        updatePrice();
        refreshAllColorNames();
        // Beim Laden bewusst KEIN Galerie-Wechsel -> 1. Bild bleibt sichtbar.
      }

      form.addEventListener('change', function (e) {
        if (e.target.matches('input[name="pm_mode"]')) {
          updateModeClass();
          updatePrice();
        } else if (e.target.matches('input[name^="pm_ring"][name$="_color"]')) {
          updatePrice();
          switchGalleryTo(e.target); // nur bei aktiver Farbwahl
          updateColorName(e.target);
        }
      });

      // -------- Add to Cart --------
      var submitBtn = form.querySelector('[data-pm-submit]');

      // Initialen sind IMMER Pflicht (unabhaengig von Settings).
      function requiredFields() {
        var rings = isDuo() ? [1, 2] : [1];
        var fields = [];
        rings.forEach(function (r) {
          var scope = form.querySelector('[data-ring="' + r + '"]');
          if (!scope) return;
          scope.querySelectorAll('[data-initial]').forEach(function (inp) { fields.push(inp); });
        });
        return fields;
      }

      function isComplete() {
        if (!checkedColor(1)) return false;
        if (isDuo() && !checkedColor(2)) return false;
        return requiredFields().every(function (inp) { return inp.value.trim() !== ''; });
      }

      function setBtnState() {
        if (!submitBtn) return;
        var ok = isComplete();
        submitBtn.classList.toggle('is-disabled', !ok);
        submitBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
      }

      function markInvalids() {
        var firstEmpty = null;
        requiredFields().forEach(function (inp) {
          var empty = !inp.value.trim();
          inp.setAttribute('aria-invalid', empty ? 'true' : 'false');
          if (empty && !firstEmpty) firstEmpty = inp;
        });
        return firstEmpty;
      }

      function ringProperties(ring) {
        var scope = form.querySelector('[data-ring="' + ring + '"]') || form;
        var first = scope.querySelector('[data-initial="first"]');
        var second = scope.querySelector('[data-initial="second"]');
        var props = {};
        if (first) props['1. Initiale'] = first.value.trim().toUpperCase();
        if (second) props['2. Initiale'] = second.value.trim().toUpperCase();
        return props;
      }

      function showError(msg) {
        var box = form.querySelector('[data-pm-error]');
        if (box) { box.textContent = msg; box.hidden = false; }
      }
      function clearError() {
        var box = form.querySelector('[data-pm-error]');
        if (box) box.hidden = true;
      }

      function addToCart() {
        clearError();

        if (!isComplete()) {
          var firstEmpty = markInvalids();
          showError('Bitte fülle alle Initialen aus, bevor du den Ring in den Warenkorb legst.');
          if (firstEmpty) firstEmpty.focus();
          return;
        }

        var items = [];
        var c1 = checkedColor(1);
        if (isDuo()) {
          var c2 = checkedColor(2);
          items.push({ id: parseInt(c1.getAttribute('data-variant-id'), 10), quantity: 1, properties: ringProperties(1) });
          items.push({ id: parseInt(c2.getAttribute('data-variant-id'), 10), quantity: 1, properties: ringProperties(2) });
        } else {
          items.push({ id: parseInt(c1.getAttribute('data-variant-id'), 10), quantity: 1, properties: ringProperties(1) });
        }

        if (submitBtn) { submitBtn.setAttribute('aria-busy', 'true'); submitBtn.classList.add('is-loading'); }

        fetch(form.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (submitBtn) { submitBtn.removeAttribute('aria-busy'); submitBtn.classList.remove('is-loading'); }
            if (!res.ok) {
              showError((res.data && (res.data.description || res.data.message)) || 'Konnte nicht in den Warenkorb gelegt werden.');
              return;
            }
            var after = form.dataset.afterAdd || 'cart';
            if (after === 'none') {
              // Nichts tun: Warenkorb-App (z. B. UpCart) oeffnet sich selbst.
            } else if (after === 'cart') {
              window.location.href = form.dataset.cartUrl;
            } else {
              // Auf der Seite bleiben: Seite neu laden, damit Horizons
              // Warenkorb-Anzeige (Zaehler/Drawer) garantiert aktuell ist.
              window.location.reload();
            }
          })
          .catch(function () {
            if (submitBtn) { submitBtn.removeAttribute('aria-busy'); submitBtn.classList.remove('is-loading'); }
            showError('Netzwerkfehler. Bitte erneut versuchen.');
          });
      }

      // Klick auf den Button (type="button") -> unsere Logik.
      form.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pm-submit]');
        if (!btn) return;
        e.preventDefault();
        addToCart();
      });

      // Enter in einem Textfeld -> ebenfalls unsere Logik, nie native Submission.
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart();
      });

      // Live: Button-Zustand und Fehler-Markierungen aktualisieren.
      form.addEventListener('input', function (e) {
        if (e.target.matches('[data-initial]')) {
          if (e.target.value.trim()) e.target.setAttribute('aria-invalid', 'false');
          setBtnState();
        }
      });
      form.addEventListener('change', function () { setBtnState(); });

      recompute();
      setBtnState();
    }

    // ============================================================
    // Varianten-Bloecke mit [data-pm-brs] — produktunabhaengig
    //
    // Konventionen, an die sich jeder Block halten muss:
    //   [name="pm_color"] / [name="pm_size"]  -> Produkt-Optionen
    //   [name^="pm_stone"]                    -> Geburtssteine
    //   [data-pm-required]                    -> Pflichtfeld
    //   [data-pm-prop-label="X"]              -> Warenkorb-Eigenschaft "X"
    //
    // Die Zuordnung Auswahlwert -> Variante ist POSITIONSUNABHAENGIG:
    // der gewaehlte Wert wird gegen alle Optionen der Variante geprueft.
    // Damit ist egal, ob die Groesse auf Option 1 oder 2 liegt.
    //
    // Diagnose im Browser: window.pmDiagnose()  oder  ?pm_debug=1
    // ============================================================
    function initBuyBoxBRS(section, form, brs, moneyFormat) {
      var submitBtn = form.querySelector('[data-pm-submit]');

      var OPTION_FIELDS = ['pm_color', 'pm_size'];
      var OPTION_LABELS = { pm_color: 'Farbe', pm_size: 'Größe' };

      // Varianten-Blob laden
      var variants = [];
      var blob = brs.querySelector('[data-pm-brs-variants]');
      if (blob) { try { variants = JSON.parse(blob.textContent); } catch (e) { variants = []; } }

      function checkedVal(name) {
        // Dropdown ODER Radios unterstuetzen
        var sel = form.querySelector('select[name="' + name + '"]');
        if (sel) return sel.value || null;
        var i = form.querySelector('input[name="' + name + '"]:checked');
        return i ? i.value : null;
      }

      // -------- Optionen: nur die, die der Block wirklich rendert --------
      function selectedOptions() {
        var out = [];
        OPTION_FIELDS.forEach(function (n) {
          if (form.querySelector('[name="' + n + '"]')) {
            out.push({ field: n, label: OPTION_LABELS[n] || n, value: checkedVal(n) });
          }
        });
        return out;
      }
      function variantOptions(v) {
        return [v.o1, v.o2, v.o3].filter(function (x) { return x !== null && x !== undefined && x !== ''; });
      }
      function firstAvailable() {
        for (var i = 0; i < variants.length; i++) { if (variants[i].available) return variants[i]; }
        return variants[0] || null;
      }
      function resolveVariant() {
        if (!variants.length) return null;
        var sel = selectedOptions();

        // Block rendert gar keine Optionen -> erste verfuegbare Variante
        if (!sel.length) return firstAvailable();

        // Ein Auswahlfeld ist noch leer -> noch keine Entscheidung moeglich
        for (var k = 0; k < sel.length; k++) { if (!sel[k].value) return null; }

        for (var i = 0; i < variants.length; i++) {
          var opts = variantOptions(variants[i]);
          var all = true;
          for (var j = 0; j < sel.length; j++) {
            if (opts.indexOf(sel[j].value) === -1) { all = false; break; }
          }
          if (all) return variants[i];
        }
        return null;
      }

      // -------- Geburtssteine: nur pruefen, was der Block mitbringt --------
      function stoneNames() {
        var seen = {}, out = [];
        form.querySelectorAll('[name^="pm_stone"]').forEach(function (el) {
          if (!seen[el.name]) { seen[el.name] = true; out.push(el.name); }
        });
        out.sort(function (a, b) {
          return (parseInt(a.replace(/\D+/g, ''), 10) || 0) - (parseInt(b.replace(/\D+/g, ''), 10) || 0);
        });
        return out;
      }
      function stonesComplete() {
        return stoneNames().every(function (n) { return !!checkedVal(n); });
      }

      // -------- Pflicht-Freitextfelder (z. B. pm_name) --------
      function fieldValue(el) {
        return String(el.value == null ? '' : el.value).trim();
      }
      function requiredFields() {
        return Array.prototype.slice.call(form.querySelectorAll('[data-pm-required]'));
      }
      function requiredComplete() {
        return requiredFields().every(function (el) { return fieldValue(el) !== ''; });
      }
      function markInvalids() {
        var firstEmpty = null;
        requiredFields().forEach(function (el) {
          var empty = fieldValue(el) === '';
          el.setAttribute('aria-invalid', empty ? 'true' : 'false');
          if (empty && !firstEmpty) firstEmpty = el;
        });
        return firstEmpty;
      }

      // -------- Warenkorb-Eigenschaften --------
      function collectProperties() {
        var props = {};
        stoneNames().forEach(function (name) {
          var val = checkedVal(name);
          if (val) props['Geburtsstein ' + name.replace(/\D+/g, '')] = val;
        });
        form.querySelectorAll('[data-pm-prop-label]').forEach(function (el) {
          var label = el.getAttribute('data-pm-prop-label');
          var val = fieldValue(el);
          if (label && val) props[label] = val;
        });
        return props;
      }

      function showError(msg) {
        var box = form.querySelector('[data-pm-error]');
        if (box) { box.textContent = msg; box.hidden = false; }
      }
      function clearError() {
        var box = form.querySelector('[data-pm-error]');
        if (box) box.hidden = true;
      }

      function updatePriceFromVariant(v) {
        if (!v) return;
        fmtInto('[data-pm-price]', '[data-pm-compare]', v.price, v.compare_at_price || 0);
        fmtInto('[data-pm-solo-price]', '[data-pm-solo-compare]', v.price, v.compare_at_price || 0);
        // Optional: Galerie an Metallfarbe koppeln (nur bei aktiver Farbwahl)
        if (v.media) {
          var slide = section.querySelector('[data-pm-slide][data-media-id="' + v.media + '"]');
          var track = section.querySelector('[data-pm-track]');
          if (slide && track) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      }
      function fmtInto(priceSel, compareSel, priceCents, compareCents) {
        var priceEl = form.querySelector(priceSel);
        var compareEl = form.querySelector(compareSel);
        if (priceEl && !isNaN(priceCents)) priceEl.textContent = formatMoney(priceCents, moneyFormat);
        if (compareEl) {
          if (compareCents > priceCents) {
            compareEl.textContent = formatMoney(compareCents, moneyFormat);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      }

      function isComplete() {
        var v = resolveVariant();
        if (!v || !v.available) return false;
        if (!stonesComplete()) return false;
        return requiredComplete();
      }
      function setBtnState() {
        if (!submitBtn) return;
        var ok = isComplete();
        submitBtn.classList.toggle('is-disabled', !ok);
        submitBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
      }

      // -------- Diagnose: warum ist der Button gesperrt? --------
      function diagnose() {
        var v = resolveVariant();
        var d = {
          variantenImBlob: variants.length,
          optionsfelder: selectedOptions(),
          aufgeloesteVariante: v ? { id: v.id, o1: v.o1, o2: v.o2, verfuegbar: v.available } : null,
          geburtssteine: stoneNames().map(function (n) { return { feld: n, wert: checkedVal(n) }; }),
          pflichtfelder: requiredFields().map(function (el) {
            return { feld: el.name || '(ohne name)', label: el.getAttribute('data-pm-prop-label'), wert: fieldValue(el) };
          }),
          eigenschaften: collectProperties(),
          buttonAktiv: isComplete()
        };
        if (!d.buttonAktiv) {
          if (!variants.length) d.grund = 'Varianten-Blob ist leer — der Block rendert [data-pm-brs-variants] nicht.';
          else if (!v && selectedOptions().some(function (o) { return !o.value; })) d.grund = 'Ein Auswahlfeld hat keinen Wert.';
          else if (!v) d.grund = 'Kein Treffer: der gewaehlte Wert kommt in keiner Variante vor (Optionswert stimmt nicht mit dem Blob ueberein).';
          else if (!v.available) d.grund = 'Variante ist ausverkauft.';
          else if (!stonesComplete()) d.grund = 'Nicht alle Geburtssteine gewaehlt.';
          else d.grund = 'Pflichtfeld leer.';
        }
        return d;
      }
      window.pmDiagnose = diagnose;
      if (window.location.search.indexOf('pm_debug') !== -1) {
        console.log('[PDP-Diagnose]', diagnose());
      }

      function addToCart() {
        clearError();
        var v = resolveVariant();

        if (!v) {
          var offen = selectedOptions().filter(function (o) { return !o.value; });
          showError(offen.length
            ? 'Bitte ' + offen.map(function (o) { return o.label; }).join(' und ') + ' wählen.'
            : 'Diese Kombination ist nicht verfügbar.');
          return;
        }
        if (!v.available) { showError('Diese Kombination ist leider ausverkauft.'); return; }

        if (!stonesComplete()) {
          showError(stoneNames().length === 2
            ? 'Bitte beide Geburtssteine wählen.'
            : 'Bitte alle Geburtssteine wählen.');
          return;
        }

        var firstEmpty = markInvalids();
        if (firstEmpty) {
          var label = firstEmpty.getAttribute('data-pm-prop-label');
          showError(label
            ? 'Bitte „' + label + '" ausfüllen, bevor du in den Warenkorb legst.'
            : 'Bitte fülle alle Pflichtfelder aus, bevor du in den Warenkorb legst.');
          firstEmpty.focus();
          return;
        }

        var props = collectProperties();

        if (submitBtn) { submitBtn.setAttribute('aria-busy', 'true'); submitBtn.classList.add('is-loading'); }

        fetch(form.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (submitBtn) { submitBtn.removeAttribute('aria-busy'); submitBtn.classList.remove('is-loading'); }
            if (!res.ok) {
              showError((res.data && (res.data.description || res.data.message)) || 'Konnte nicht in den Warenkorb gelegt werden.');
              return;
            }
            var after = form.dataset.afterAdd || 'none';
            if (after === 'none') { /* Warenkorb-App uebernimmt */ }
            else if (after === 'cart') { window.location.href = form.dataset.cartUrl; }
            else { window.location.reload(); }
          })
          .catch(function () {
            if (submitBtn) { submitBtn.removeAttribute('aria-busy'); submitBtn.classList.remove('is-loading'); }
            showError('Netzwerkfehler. Bitte erneut versuchen.');
          });
      }

      // Klick auf Button (type=button)
      form.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pm-submit]');
        if (!btn) return;
        e.preventDefault();
        addToCart();
      });
      // Enter -> ebenfalls unsere Logik
      form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });

      // Zustands-Updates
      form.addEventListener('change', function (e) {
        if (e.target.name && OPTION_FIELDS.indexOf(e.target.name) !== -1) {
          var v = resolveVariant();
          if (v) updatePriceFromVariant(v);
        }
        setBtnState();
      });

      // Tippen im Pflichtfeld -> Button sofort freischalten (change kaeme erst
      // beim Verlassen des Feldes).
      form.addEventListener('input', function (e) {
        if (e.target.matches('[data-pm-required]')) {
          if (fieldValue(e.target) !== '') e.target.setAttribute('aria-invalid', 'false');
          setBtnState();
        }
      });

      // Initial: Preis aus vorausgewaehlter Variante
      var initial = resolveVariant();
      if (initial) updatePriceFromVariant(initial);
      setBtnState();
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-pm-section]').forEach(function (section) {
        initGallery(section);
        initBuyBox(section);
      });
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });

    // Theme-Editor: bei Section-Reload neu initialisieren
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeader(root) {
      (root || document).querySelectorAll('[data-pm-header]').forEach(function (header) {
        if (header.dataset.pmReady) return;
        header.dataset.pmReady = '1';

        // --- Suche ---
        var searchToggle = header.querySelector('[data-pm-search-toggle]');
        var searchBar = header.querySelector('[data-pm-search]');
        var searchInput = header.querySelector('[data-pm-search-input]');
        var searchClose = header.querySelector('[data-pm-search-close]');
        function openSearch() { if (!searchBar) return; searchBar.hidden = false; if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true'); if (searchInput) searchInput.focus(); }
        function closeSearch() { if (!searchBar) return; searchBar.hidden = true; if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false'); }
        if (searchToggle && searchBar) {
          searchToggle.addEventListener('click', function () { if (searchBar.hidden) openSearch(); else closeSearch(); });
        }
        if (searchClose) searchClose.addEventListener('click', closeSearch);
        // Schließen bei Klick außerhalb
        document.addEventListener('click', function (e) {
          if (!searchBar || searchBar.hidden) return;
          if (searchBar.contains(e.target)) return;
          if (searchToggle && searchToggle.contains(e.target)) return;
          closeSearch();
        });
        // Schließen mit Escape
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && searchBar && !searchBar.hidden) closeSearch();
        });
      });
    }

    function initDrawer(root) {
      (root || document).querySelectorAll('[data-pm-drawer]').forEach(function (drawer) {
        if (drawer.dataset.pmReady) return;
        drawer.dataset.pmReady = '1';

        var toggle = document.querySelector('[data-pm-menu-toggle]');
        var panel = drawer.querySelector('.pm-drawer__panel');
        var closers = drawer.querySelectorAll('[data-pm-drawer-close]');

        function open() {
          drawer.hidden = false;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { drawer.classList.add('is-open'); });
          });
          document.documentElement.style.overflow = 'hidden';
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
        }
        function close() {
          drawer.classList.remove('is-open');
          document.documentElement.style.overflow = '';
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          var done = function () { drawer.hidden = true; if (panel) panel.removeEventListener('transitionend', done); };
          if (panel) panel.addEventListener('transitionend', done);
          else drawer.hidden = true;
        }

        if (toggle) toggle.addEventListener('click', open);
        closers.forEach(function (c) { c.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
      });
    }

    function init(root) { initHeader(root); initDrawer(root); }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-related]').forEach(function (grid) {
        if (grid.dataset.pmReady) return;
        grid.dataset.pmReady = '1';
        if (grid.children.length > 0) return; // schon befüllt

        var url = grid.getAttribute('data-url');
        if (!url) return;

        function hide() { var sec = grid.closest('.pm-related'); if (sec) sec.style.display = 'none'; }

        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fetched = doc.querySelector('[data-pm-related]');
            if (fetched && fetched.innerHTML.trim()) {
              grid.innerHTML = fetched.innerHTML;
            } else {
              hide();
            }
          })
          .catch(hide);
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-reviews-grid]').forEach(function (grid) {
        if (grid.dataset.pmReady) return;
        grid.dataset.pmReady = '1';

        var section = grid.closest('.pm-reviews');
        var btn = section ? section.querySelector('[data-pm-reviews-more]') : null;
        var visible = parseInt(grid.dataset.visible, 10) || 4;
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.pm-review'));

        if (cards.length <= visible) { if (btn) btn.hidden = true; return; }

        var expanded = false;
        function apply() {
          cards.forEach(function (c, i) { c.classList.toggle('is-hidden', !expanded && i >= visible); });
          if (btn) btn.textContent = expanded ? (btn.dataset.less || 'Show less') : (btn.dataset.more || 'Show more reviews');
        }
        apply();
        if (btn) {
          btn.hidden = false;
          btn.addEventListener('click', function () { expanded = !expanded; apply(); });
        }
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
